import type { IIntervalHandle, IIntervalTimer } from '@talbenmoshe/trip-os-react-model';

/** The part of the browser's `window` this adapter needs, so tests can pass a stand-in. */
export interface IIntervalHost {
  setInterval(callback: () => void, intervalMilliseconds: number): number;
  clearInterval(intervalId: number): void;
}

class WindowIntervalHandle implements IIntervalHandle {
  constructor(
    private readonly host: IIntervalHost,
    private readonly intervalId: number
  ) {}

  stop(): void {
    this.host.clearInterval(this.intervalId);
  }
}

/** Repeats a callback with the browser's `setInterval`; the returned handle clears it. */
export class WindowIntervalTimer implements IIntervalTimer {
  constructor(private readonly host: IIntervalHost) {}

  start(intervalMilliseconds: number, callback: () => void): IIntervalHandle {
    const intervalId = this.host.setInterval(callback, intervalMilliseconds);

    return new WindowIntervalHandle(this.host, intervalId);
  }
}
